import Avatar                             from "@components/avatar"
import { useContext }                     from "react"

import {
  CardText,
  Badge,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap"

import {
  MoreVertical
} from 'react-feather'

import {
  setAsAdmin,
  removeAdmin,
  removeMember
} from "../../../../services/pages/chat/roomChat"

import {
  ChatWsContext
} from ".."

import { fallbackImage_ } from "../../../../helpers/default_helper"

export const CardGroupMember = (props) => {

  // CONTEXT
  const {
    handleSetListMember
  } = useContext(ChatWsContext)

  function handleSetAdmin(admin_id, room_id) {
    setAsAdmin([admin_id], room_id)
      .then((response) => {
        handleSetListMember(response)
      })
  }

  function handleRemoveAdmin(admin_id, room_id) {
    removeAdmin([admin_id], room_id)
      .then((response) => {
        handleSetListMember(response)
      })
  }

  function handleRemoveMember(uuid, room_id) {
    removeMember([uuid], room_id)
      .then((response) => {
        handleSetListMember(response)
      })
  }

  return (
    <li
      className="d-flex p-1 px-2 text-decoration-none list-group-item justify-content-between cursor-pointer"
    >
      <Avatar onError={fallbackImage_} img={props.member.avatar} imgHeight='42' imgWidth='42' style={{ marginRight: 12 }} className="border border-white" />

      <div className='chat-info flex-grow-1'>
        <strong className='mb-0'>
          {props.member.name}
        </strong>
        <CardText className='text-muted'>
          {props.member.origin}
        </CardText>
      </div>

      {
        props.isAdmin ? (
          <Badge color='light-primary pl-1 pr-1 pt-1'>
            Admin
          </Badge>
        ) : null
      }

      {
        <UncontrolledButtonDropdown className="ml-1 d-lg-block d-none">
          {
            props.meAsAdmin ? (
              !props.isMe ? (
                <DropdownToggle tag='span' >
                  <MoreVertical size={20} className='cursor-pointer' />
                </DropdownToggle>
              ) : null
            ) : null
          }
          <DropdownMenu direction='start'>
            {
              props.isAdmin ? (
                <>
                  <DropdownItem className='w-100' onClick={() => handleRemoveAdmin(props.member.uuid, props.idRoom)}>
                    <span className='align-middle'>Batal Jadikan Admin</span>
                  </DropdownItem>
                </>
              ) : (
                <>
                  <DropdownItem className='w-100' onClick={() => handleSetAdmin(props.member.uuid, props.idRoom)}>
                    <span className='align-middle'>Jadikan Admin</span>
                  </DropdownItem>
                  <DropdownItem className='w-100' onClick={() => handleRemoveMember(props.member.uuid, props.idRoom)}>
                    <span className='align-middle'>Keluarkan Dari Grup</span>
                  </DropdownItem>
                </>
              )
            }
          </DropdownMenu>
        </UncontrolledButtonDropdown>
      }
    </li >
  )
}